<template>
    <v-card flat class="w-100" v-bind="$attrs">
        <slot />
        <v-tabs v-model="type" hide-slider class="v-tabs--primary v-tabs--block">
            <v-tab :value="item.value" v-for="item in userTypes" :key="item.value">{{ item.text }}</v-tab>
        </v-tabs>
        <!-- <v-chip-group v-model="type" class="mt-20">
            <v-row>
                <v-col v-for="item in userTypes" :key="item.value">
                    <v-chip :value="item.value" large outlined tag="v-btn" class="v-btn--block">{{ item.text }}</v-chip>
                </v-col>
            </v-row>
        </v-chip-group> -->
        <!-- <v-row class="ma-0 mt-30">
            <v-col v-for="item in userTypes" :key="item.value">
                <v-btn v-model="type" block :value="item.value" outlined active-class="primary--text">{{ item.text }}</v-btn>
            </v-col>
        </v-row> -->
        <v-text-field v-model="username" outlined hide-details placeholder="아이디" type="text" class="mt-20 mt-lg-40" />
        <v-text-field v-model="password" @keydown.enter="login" outlined hide-details placeholder="비밀번호" type="password" class="mt-8 mt-lg-12" />
        <v-checkbox v-model="remember" :value="true" label="로그인 유지" hide-details class="mt-8 mt-lg-12" />
        <v-btn @click="login" large color="primary" class="w-100 mt-14 mt-lg-24">로그인</v-btn>
        <div class="mt-8 mt-lg-12">
            <v-row no-gutters justify="center" align="center">
                <v-col cols="auto">
                    <dialog-find-idpw>
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" text x-small color="grey-6"><span class="font-weight-regular">아이디/비밀번호찾기</span></v-btn>
                        </template>
                    </dialog-find-idpw>
                </v-col>
                <v-col cols="auto" class="mx-4">
                    <span class="menu-line"></span>
                </v-col>
                <v-col cols="auto">
                    <v-btn text x-small color="grey-6"><span class="font-weight-regular" @click="$refs['dialog-join'].shows = true">회원가입</span></v-btn>
                </v-col>
            </v-row>
        </div>
        <dialog-join ref="dialog-join" />

        <!-- <v-row no-gutters class="mt-10" justify="center">
            <v-col cols="auto"> <v-btn small text @click="$emit('findId')">아이디/비밀번호찾기</v-btn> </v-col>
            <v-col cols="auto"> <v-divider vertical /></v-col>
            <v-col cols="auto"><v-btn small text @click="$emit('join')">회원가입</v-btn></v-col>
        </v-row> -->
    </v-card>
</template>

<script>
import CryptoAES from "@/plugins/crypto-aes";
import { USER_TYPES } from "@/assets/variables";
import DialogFindIdpw from "@/components/client/login/dialog-find-idpw.vue";
import DialogJoin from "../join/dialog-join/dialog-join.vue";

const userTypes = Object.values(USER_TYPES);

export default {
    components: {
        DialogFindIdpw,
        DialogJoin,
    },
    data: () => ({
        type: USER_TYPES.PERSON.value,
        username: null,
        password: null,
        remember: false,

        userTypes,
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.$cookies.get("username")) this.username = this.$cookies.get("username");
            // if(this.$cookies.get('password')) this.password = CryptoAES.decrypt(this.$cookies.get('password'));
        },
        async login() {
            try {
                let { username, password, remember } = this;
                let usertype = userTypes[this.type]?.value;
                await this.$store.dispatch("login", { username, password, remember, usertype });

                if (remember) {
                    this.$cookies.set("username", username);
                    // this.$cookies.set("password", CryptoAES.encrypt(password));
                }

                this.$emit("loggedIn");
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message);
            }
        },
    },
};
</script>

<style></style>
